/** Prépare treatmentSpecs pour handleSaveDetails (clés camelCase attendues par case-detail). */
export function buildTreatmentSpecsPayloadFromCase(caseData) {
  const t = caseData?.treatmentSpecs;
  const base = {
    archToTreat: caseData?.archToTreat || caseData?.arch_to_treat || '',
    treatmentType: caseData?.treatmentType || caseData?.treatment_type || '',
    questionsNotes: caseData?.questionsNotes || caseData?.questions_notes || '',
    overjet: '',
    overbite: '',
    midline: '',
    posteriorCrossbite: '',
    spacing: '',
    sequentialDistalization: '',
    expand: { upper: '', lower: '' },
    procline: { upper: '', lower: '' },
    canine: { upper: '', lower: '' },
    molar: { upper: '', lower: '' },
    iprAnterior: { upper: '', lower: '' },
    iprPosteriorRight: { upper: '', lower: '' },
    iprPosteriorLeft: { upper: '', lower: '' },
    toothMovementRestrictions: [],
    attachmentRestrictions: [],
    extractions: [],
    missingTeeth: [],
  };
  if (!t) return base;
  return {
    ...base,
    overjet: t.overject || '',
    overbite: t.overbite || '',
    midline: t.midline || '',
    posteriorCrossbite: t.posterior_crossbite || '',
    spacing: t.spacing || '',
    sequentialDistalization: t.sequential_distalization || '',
    expand: t.expand || { upper: '', lower: '' },
    procline: t.procline || { upper: '', lower: '' },
    canine: t.canine || { upper: '', lower: '' },
    molar: t.molar || { upper: '', lower: '' },
    iprAnterior: t.ipr_anterior || { upper: '', lower: '' },
    iprPosteriorRight: t.ipr_posterior_right || { upper: '', lower: '' },
    iprPosteriorLeft: t.ipr_posterior_left || { upper: '', lower: '' },
    toothMovementRestrictions: t.tooth_mvt_restrictions || [],
    attachmentRestrictions: t.attachment_restrictions || [],
    extractions: t.extractions || [],
    missingTeeth: t.missing_teeth || [],
  };
}

/** Enregistrement prescription uniqué : évite d'écraser le formulaire avec d'anciennes valeurs locales. */
export function formSnapshotFromCase(caseData) {
  return {
    caseType: caseData?.caseType,
    treatmentType: caseData?.treatmentType,
    priority: caseData?.priority,
    notes: caseData?.notes,
    archToTreat: caseData?.archToTreat,
    patientName: caseData?.patientName,
    patientDOB: caseData?.patientDOB,
    patientId: caseData?.patientId,
    patientContact: caseData?.patientContact,
  };
}
